module.exports = __webpack_public_path__ + "img/报表平台select.551a03b1.svg";